import { balanceState, useCreditBalance } from '../lib/credits';

// The balance in the top bar (204): always visible, moves after every press.
export function CreditPill({ onOpen }: { onOpen: () => void }) {
  const { credits } = useCreditBalance();
  const state = balanceState(credits);
  if (!credits || state === 'unmetered') return null;
  const title = `${credits.balance.plan.toLocaleString()} from the plan · ${credits.balance.purchased.toLocaleString()} bought · renews ${new Date(credits.plan.renewsAt).toLocaleDateString()}`;
  return (
    <button type="button" className={`creditpill ${state}`} data-tool="credits" title={title} onClick={onOpen}>
      {Math.max(0, Math.floor(credits.balance.total)).toLocaleString()} cr
    </button>
  );
}
